const styles = {
  '@global .ui.card, .ui.cards > .card': {
    boxShadow:
      '0 .0625rem 0 0 rgba(0,0,0,0.03), 0 .125rem .375rem 0 rgba(0,0,0,0.06); !important',
  },
  card: {
    width: '19.75em !important',
    margin: '2em !important',
  },
  cardHeader: {
    padding: '1.1875em 1em !important',

    '& .header': {
      color: '#fff !important',
      fontSize: '1.0625em !important',
      fontWeight: 500,
      lineHeight: '1.3125em !important',
      marginTop: '.796875em !important',
    },

    '& .meta': {
      color: '#fff !important',
      fontSize: '.75em !important',
      fontWeight: 500,
      lineHeight: '.9375em !important',
      opacity: 0.7,
    },

    '& div': {
      fontWeight: '500 !important',
    },
  },
  logo: {
    boxSizing: 'border-box' as const,
    height: '3.71875em',
    width: '3.71875em',
    border: '.078125em solid #F5F5F5',
    borderRadius: '1.34375em',
    backgroundColor: '#fff !important',
  },
  label: {
    fontSize: '.875em !important',
    color: '#797979 !important',
  },
  onboarded: {
    fontSize: '.75em !important',
    fontWeight: 'bold',
    color: '#797979 !important',
  },
  value: {
    fontSize: '.9375em !important',
    color: '#585858 !important',
    textTransform: 'capitalize !important' as 'capitalize',
  },
  icon: {
    height: '1.6875em !important',
    width: '1.6875em !important',
    marginRight: '.5em !important',
  },
  statusPill: {
    alignItems: 'center !important',
    borderRadius: '.625rem !important',
    backgroundColor: '#a9b8c2 !important',
    color: '#fff !important',
    display: 'flex !important',
    fontSize: '.75rem !important',
    height: '1.125rem !important',
    justifyContent: 'center !important',
    width: '4.75rem !important',
    marginLeft: 'auto !important',
    padding: '0 !important',
    textAlign: 'center',
    '&.activePill': {
      backgroundColor: '#39e27a !important',
    },
  },
};

export default styles;
